import React from "react";
import { DialogActions, useTheme } from "@mui/material";

const ModalActions = (props) => {
  const { children, hideBorder } = props;
  const theme = useTheme();

  return (
    <DialogActions
      sx={{
        background: theme.branding.gray[0],
        borderTop: (props) =>
          hideBorder ? "none" : `1px solid ${theme.branding.gray[200]}`,
        marginTop: "auto",
        padding: "16px 24px",
        position: "sticky",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
      }}
    >
      {children}
    </DialogActions>
  );
};

export default ModalActions;
